export default "__VITE_ASSET__B2NsctqF__"